import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "@/assets/cmg360/logo-white.png";
import lightModeLogo from "@/assets/cmg360/logo-black.png";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "COP";

export const defaultTitle = "CMG360";

// CMG360 values. Labels are runtime data shown to the agency team (Spanish).
export const defaultCompanySectors = [
  { value: "food", label: "Restaurantes y alimentos" },
  { value: "health", label: "Salud" },
  { value: "beauty", label: "Belleza y bienestar" },
  { value: "construction", label: "Construcción e inmobiliaria" },
  { value: "hospitality", label: "Hotelería y turismo" },
  { value: "finance", label: "Finanzas" },
  { value: "retail", label: "Comercio y retail" },
  { value: "professional-services", label: "Servicios profesionales" },
  { value: "education", label: "Educación" },
  { value: "events", label: "Eventos y entretenimiento" },
  { value: "other", label: "Otro" },
];

export const defaultDealStages = [
  { value: "new", label: "Nuevo" },
  { value: "diagnosis-scheduled", label: "Diagnóstico agendado" },
  { value: "proposal-sent", label: "Propuesta enviada" },
  { value: "negotiation", label: "Negociación" },
  { value: "won", label: "Ganado" },
  { value: "lost", label: "Perdido" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "creative-direction", label: "Dirección creativa" },
  { value: "content-social", label: "Contenido y redes sociales" },
  { value: "web", label: "Desarrollo web" },
  { value: "paid-media", label: "Pauta digital" },
  { value: "full-360", label: "Paquete 360 (todo en uno)" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frío", color: "#7dbde8" },
  { value: "warm", label: "Tibio", color: "#f5a524" },
  { value: "hot", label: "Caliente", color: "#ff6b5d" },
  { value: "in-contract", label: "Cliente", color: "#3dd68c" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Ninguno" },
  { value: "call", label: "Llamada" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Correo" },
  { value: "meeting", label: "Reunión" },
  { value: "diagnosis", label: "Diagnóstico" },
  { value: "send-proposal", label: "Enviar propuesta" },
  { value: "follow-up", label: "Seguimiento" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
